import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { Country } from '../API/Enums';

/**
 * Returns true if the value is a finite number or can be cast to a finite number
 * @param num value to test
 */
export const isNumeric = (num: any) => {
    if (typeof num === 'number') {
        return num - num === 0;
    }
    if (typeof num === 'string' && num.trim() !== '') {
        return Number.isFinite ? Number.isFinite(+num) : isFinite(+num);
    }

    return false;
};

export const formatAsPhoneNumber = (phoneNumber: string | number, discrete: boolean = false) => {
    let number = (phoneNumber && parsePhoneNumberFromString(phoneNumber.toString(), 'US')
        ?.formatNational()) || '';

    if (number && discrete) {
        const front = number.substring(0, number.length - 4)
            .replace(/[0-9]/g, 'X');
        const back = number.slice(number.length - 4);
        number = front + back;
    }

    return number;
};

/**
 * Formats a number into a currency.
 * @param num Number to format
 * @param nonZeroOnly Whether a 0 value should be formatted
 */
export const formatAsCurrency = (num?: number | null, nonZeroOnly = false, country: Country = Country.USA) => {
    // TODO: localize
    if (num !== null && num !== undefined && (num > 0 || !nonZeroOnly)) {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: country === Country.Canada ? 'CAD' : 'USD',
        });

        return formatter.format(num);
    }

    return '';
};
